import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { CoreService } from '@app/core/services';
import {  ROUTES } from 'src/utils/constants';
import { LanguageCode } from 'src/utils/enums';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-auth-main-container',
  templateUrl: './auth-main-container.component.html',
  styleUrls: ['./auth-main-container.component.scss'],
})
export class AuthMainContainerComponent implements OnInit, OnDestroy {
  activeText: number = 1;
  activeLanguage = LanguageCode.UK;
  stage: string = 'login';
  destroyed$ = new Subject<boolean>();

  constructor(
    private router: Router,
    private translate: TranslateService,
    private coreService: CoreService,
    private sanitizer: DomSanitizer,

) {
    router.events.subscribe((val: any) => {
      if (val instanceof NavigationEnd) {
        this.stage = this.router.url
          .replace(`${ROUTES.AUTH.AUTH}/`, '')
          .split('?')[0];
      }
    });
  }

  ngOnInit(): void {
    this.stage = this.router.url
      .replace(`${ROUTES.AUTH.AUTH}/`, '')
      .split('?')[0];
    this.translate.use(this.activeLanguage);
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  highlightText(text: string): SafeHtml {
    const regex = /\^(.*?)\^/g;
    const replacedText = text.replace(regex, '<span style="font-weight: 700;">$1</span>');
    return this.sanitizer.bypassSecurityTrustHtml(replacedText);
  }
  slide(direction: string) {
    if (direction === 'next') {
      this.activeText !== 3 ? this.activeText++ : (this.activeText = 1);
    } else {
      this.activeText !== 1 ? this.activeText-- : (this.activeText = 3);
    }
  }

  changeStage(stage: string) {
    this.stage = stage;
  }
}
